/* NZ Supps — Build Your Stack: dynamic subscription re-tier on removal (Blake 2026-06-27).
   When a stack pick is removed and the pick count drops a tier, the remaining SUBSCRIBED stack lines
   must move to the correct composed Recharge plan:
     >=4 picks -> tier4  "10% Stack discount + 5% subscription discount"  (15%)
     2-3 picks -> tier2  "5% Stack discount + 5% subscription discount"   (10%)
   One-time lines are auto-handled by the discount Function (it re-derives picks in-cart). This only
   touches subscription selling plans, on REMOVAL only. Same-week plan preferred; NEAREST week is the
   fallback; per-line failures are tolerated (line left as-is). Watches cart-mutating fetches so it acts
   wherever a removal happens (cart drawer / cart page / review). */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TIER_LABEL = { 4: '10% stack discount + 5% subscription discount', 2: '5% stack discount + 5% subscription discount' };
  var busy = false, timer = null;
  /* NZS-RETIER-0922: the drawer hands us its fresh server cart on every render; reuse it instead of a
     second /cart.js read after every write. The fetch stays as the fallback for other surfaces. */
  var lastCart = null, lastCartAt = 0;
  document.addEventListener('nzs:cart-rendered', function (e) { var c = e.detail && e.detail.cart; if (c && c.items && c.token) { lastCart = c; lastCartAt = Date.now(); } });
  function readCart() { return (lastCart && Date.now() - lastCartAt < 2000) ? Promise.resolve(lastCart) : fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function picksOf(items) {
    var c = {};
    (items || []).forEach(function (it) { var p = it.properties || {}; if (p._Stack && !p._Free && p.Category) c[String(p.Category).toLowerCase()] = 1; });
    return Object.keys(c).length;
  }
  function tierOfName(nm) { nm = (nm || '').toLowerCase(); return nm.indexOf('10% stack discount') > -1 ? 4 : (nm.indexOf('5% stack discount') > -1 ? 2 : 0); }
  function weekOf(nm) { var m = (nm || '').match(/(\d+)\s*-?\s*week/i); return m ? parseInt(m[1], 10) : 0; }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 350); }

  function run() {
    if (busy) return;
    readCart().then(function (cart) { /* NZS-RETIER-0922 */
      var subs = (cart.items || []).filter(function (it) {
        return it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.properties && it.properties._Stack && tierOfName(it.selling_plan_allocation.selling_plan.name);
      });
      if (!subs.length) return;                                       // no composed-stack subscriptions to police
      var target = picksOf(cart.items) >= 4 ? 4 : 2;                  // nearest valid tier (tier2 floor)
      var todo = subs.filter(function (it) { return tierOfName(it.selling_plan_allocation.selling_plan.name) !== target; });
      if (!todo.length) return;                                       // every subscribed stack line already correct
      busy = true;
      var i = 0, changed = false;
      (function next() {
        if (i >= todo.length) { busy = false; if (changed) afterRetier(); return; }
        var want = todo[i++];
        applyTier(want.variant_id, weekOf(want.selling_plan_allocation.selling_plan.name), target)
          .then(function (ok) { if (ok) changed = true; next(); })
          .catch(function () { next(); });
      })();
    }).catch(function () { busy = false; });
  }

  // Re-key safe: re-fetch the cart to get the line's CURRENT key (a selling_plan change re-keys it), match by variant_id.
  function applyTier(vid, wk, target) {
    return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).filter(function (x) { return x.variant_id === vid && x.selling_plan_allocation; })[0];
      if (!line) return false;
      return fetch(ROOT + 'products/' + line.handle + '.js').then(function (r) { return r.json(); }).then(function (prod) {
        var plans = [];
        (prod.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (sp) { plans.push(sp); }); });
        var tierPlans = plans.filter(function (sp) { return (sp.name || '').toLowerCase().indexOf(TIER_LABEL[target]) > -1; });
        if (!tierPlans.length) return false;                          // product has no plan at the target tier -> leave as-is
        var exact = tierPlans.filter(function (sp) { return weekOf(sp.name) === wk; });
        var chosen = exact[0] || tierPlans.slice().sort(function (a, b) { return Math.abs(weekOf(a.name) - wk) - Math.abs(weekOf(b.name) - wk); })[0];  // nearest-week fallback
        if (!chosen) return false;
        return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, selling_plan: chosen.id }) })
          .then(function (resp) { return resp.ok; });
      });
    });
  }

  function afterRetier() {
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { document.dispatchEvent(new CustomEvent('nzs:cart-changed', { detail: c })); });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // nudge the theme's reactive (Alpine) cart to re-render the visible plan tags
    try {
      if (window.Alpine && Alpine.store) {
        ['xCart', 'cart', 'xMiniCart', 'xCartDrawer', 'xCartItems'].forEach(function (n) {
          var s; try { s = Alpine.store(n); } catch (e) { }
          if (s) ['refresh', 'get', 'fetchCart', 'update', 'sync', 'init'].forEach(function (fn) { if (typeof s[fn] === 'function') { try { s[fn](); } catch (e) { } } });
        });
      }
    } catch (e) { }
  }

  // ---- watch cart-mutating fetches; a qty/removal change (not our own selling_plan change) schedules a re-tier ----
  var of = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
    var p = of.apply(this, arguments);
    try {
      if (!busy && /\/cart\/(change|update)(\.js)?($|\?)/.test(url) && /post/i.test(method)) {
        var isPlan = false, body = init && init.body;
        try { if (typeof body === 'string') { var b = JSON.parse(body); if (b && b.selling_plan) isPlan = true; } } catch (e) { }
        if (!isPlan) p.then(function () { schedule(); });
      }
    } catch (e) { }
    return p;
  };
})();
